<script>
import { mapActions, mapGetters } from "vuex";
import AlertError from "@/components/alert_error";
import Loader from "@/components/widgets/loader";
import { swal } from "../../../helpers/handle_error";
import exportToExcel from "../../../helpers/export_to_excel";
import seasonOptions from "../../../helpers/season_options";

export default {
  components: { AlertError, Loader },
  data() {
    return {
      //Page errors.
      errors: [],
      showLoader: true,
      showAlert: false,

      items: [],

      dateRanges: seasonOptions,
      selectedDateRange: null,

      // datatable
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      totalItemsFiltered: 0,
      pageOptions: [
        10,
        25,
        50,
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        { value: Number.MAX_SAFE_INTEGER, text: "عرض الكل" },
      ],
      filter: "",
      filterOn: [],
      sortBy: "created_at",
      sortDesc: true,
      fields: [
        {
          label: "الاجراءات",
          stickyColumn: true,
          key: "settings",
          class: "col-setting-services",
          sortable: false,
          visible: this.$store.getters["auth/getUser"].hasAnyPermission([
            "show_details_artist",
            "delete_artist",
          ]),
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
        {
          // A virtual column that doesn't exist in items
          label: "ت",
          key: "index",
          class: "col-sequence",
          sortable: false,
          visible: true,
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
        {
          label: "اسم المشارك",
          key: "full_name",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "full_name",
          searchable: true,
        },
        {
          label: "الاسم الفني",
          key: "artistic_name",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "artistic_name",
          searchable: true,
        },
        {
          label: "تاريخ التولد",
          key: "birth_date",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "birth_date",
          searchable: true,
        },
        {
          label: "الجنس",
          key: "gender.name_ar",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "gender.name_ar",
          searchable: true,
        },
        {
          label: "التحصيل الدراسي",
          key: "education_level.name_ar",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "educationLevel.name_ar",
          searchable: true,
        },
        {
          label: "التخصص الدراسي",
          key: "study_specialization",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "study_specialization",
          searchable: true,
        },
        {
          label: "الدولة",
          key: "country.name_ar",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "country.name_ar",
          searchable: true,
        },
        {
          label: "المحافظة",
          key: "province",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "province",
          searchable: true,
        },
        {
          label: "رقم الهاتف-1",
          key: "phone1",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "phone1",
          searchable: true,
        },
        {
          label: "المشاركات",
          key: "artists",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
        {
          label: "تاريخ التقديم",
          key: "created_at",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "created_at",
          searchable: true,
        },
        
      ],
    };
  },
  computed: {
    ...mapGetters("formArtist", ["getArtists"]),
    start() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    end() {
      return Math.min(this.currentPage * this.perPage, this.totalItems);
    },
  },
  methods: {
    visibleFields() {
      return this.fields.filter((field) => field.visible);
    },
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    ...mapActions("formArtist", ["getAll", "delete"]),
    // datatable
    search() {
      if (this.currentPage == 1) this.fetchAll(true);
      else this.currentPage = 1;
    },
    changeDateRange() {
      if (this.currentPage == 1) this.fetchAll();
      else this.currentPage = 1;
    },
    fetchAll(is_search) {
      if (!is_search) {
        this.showLoader = true;
      }

      var query = new URLSearchParams({
        draw: this.currentPage,
        start: (this.currentPage - 1) * this.perPage,
        length: this.perPage,
      });
      query.append("_datatable", "1");
      let columns = this.fields.filter((f) => !f.isVirtual);
      columns.forEach((el, index) => {
        query.append("columns[" + index + "][data]", el.name);
        query.append("columns[" + index + "][name]", el.name);
        query.append("columns[" + index + "][orderable]", el.sortable);
        query.append("columns[" + index + "][searchable]", el.searchable);
        query.append("columns[" + index + "][search][value]", "");
        query.append("columns[" + index + "][search][regex]", "false");
      });
      query.append("search[value]", this.filter);
      query.append("search[regex]", "false");
      query.append("start_date", this.selectedDateRange.start_date);
      query.append("end_date", this.selectedDateRange.end_date);

      query.append("order[0][column]", 9);
      query.append("order[0][dir]", "desc");

      this.getAll(query)
        .then((response) => {
          this.totalItemsFiltered = response.data.recordsFiltered;
          this.totalItems = response.data.recordsTotal;

          this.items = this.getArtists;
          this.showLoader = false;
        })
        .catch((error) => {
          this.handleError(error);
          this.showLoader = false;
        });
    },
    async deleteItem(id) {
      if (await swal.confirm()) {
        swal.loading();
        this.delete(id)
          .then((response) => {
            this.fetchAll();
            swal.success(response.data.message);
          })
          .catch((error) => {
            this.handleError(error);
            swal.close();
          });
      }
    },
    exportTable() {
      const exportableFields = this.visibleFields().filter(field =>
        !["settings"].includes(field.key)
      );
      const formattedItems = this.items.map((item, i) => {
        return {
          ...item,
          index: (i + 1),
          artists: Array.isArray(item.artists)
            ? item.artists.map(artist =>
                `${artist.sub?.main?.name_ar || ''} > ${artist.sub?.name_ar || ''} > ${artist.artwork_name || ''}`
              ).join(' | ') 
            : ''
        };
      });
      exportToExcel(
        exportableFields,
        formattedItems,
        "أستمارة المشاركات الفنية"
      );
    },
  },
  watch: {
    currentPage: {
      handler: function () {
        this.fetchAll();
      },
    },
    perPage: {
      handler: function () {
        this.fetchAll();
      },
    },
  },
  created() {
    this.selectedDateRange = this.dateRanges[0].value;
    this.fetchAll();
  },
};
</script>

<template>
  <div>
    <Loader :loading="showLoader">
      <div class="row mt-3">
        <div class="col-12">
          <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

          <div class="row mb-3">
            <div class="col-12">
              <label for="form-artist-date-range">الفترة الزمنية</label>
              <b-form-select
                id="form-artist-date-range"
                v-model="selectedDateRange"
                class="form-select btn-rounded"
                :options="dateRanges"
                @change="changeDateRange"
              ></b-form-select>
            </div>
          </div>

          <!-- Header Table -->
          <div class="row mt-1">
            <!-- table_length -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  عرض&nbsp;:&nbsp;
                  <b-form-select
                    class="form-select form-select-sm btn-rounded"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  &nbsp;مدخلات
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center">
                  بحث&nbsp;:&nbsp;
                  <b-form-input
                    v-model="filter"
                    @input="search"
                    type="search"
                    placeholder="بحث..."
                    class="form-control form-control-sm ms-2 btn-rounded"
                  ></b-form-input>
                </label>
                <b-button class="btn-sm mx-2 btn-rounded" variant="primary" @click="exportTable"
                  >Excel</b-button
                >
              </div>
            </div>
          </div>

          <!-- Table -->
          <div class="table-responsive table-bordered mb-0">
            <b-table
              class="datatables datatable-auto-width fixed-columns-table"
              show-empty
              hover
              :items="items"
              :striped="true"
              :fields="visibleFields()"
              responsive="lg"
              :current-page="currentPage"
              :per-page="0"
            >
              <!-- A virtual column -->
              <template #cell(index)="data">
                {{ data.index + 1 + (currentPage - 1) * perPage }}
              </template>
              <template #cell(created_at)="data">
                {{ data.item.created_at + " " + data.item.created_at_time }}
              </template>

              <!-- A custom formatted column Artists -->
              <template v-slot:cell(artists)="data">
                <ol>
                  <li v-for="artist in data.item.artists" :key="artist.id">
                    {{ artist.sub.main.name_ar+' > '+artist.sub.name_ar+' > '+artist.artwork_name }}
                  </li>
                </ol>
              </template>

              <!-- A custom formatted column Sutting -->
              <template v-slot:cell(settings)="data">
                <div class="button-items">
                  <router-link
                    v-can="'show_details_artist'"
                    :to="{
                      name: 'form.artist.details',
                      params: { id: data.item.id },
                    }"
                  >
                    <b-button class="btn-sm btn-rounded" variant="info">التفاصيل</b-button>
                  </router-link>
                  <b-button
                    v-can="'delete_artist'"
                    class="btn-sm ml-1 btn-rounded"
                    variant="danger"
                    title="حذف"
                    @click="deleteItem(data.item.id)"
                    ><i class="bx bx-trash"></i
                  ></b-button>
                </div>
              </template>
            </b-table>
          </div>

          <!-- Footer Table -->
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalItemsFiltered"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
              <div class="dataTables_paginate paging_simple_numbers float-start">
                <p>
                  عرض من {{ start }} الى {{ end }} من مجموع {{ totalItemsFiltered }}
                  <spam v-if="totalItemsFiltered != totalItems"
                    >(تمت تصفيته من إجمالي {{ totalItems }} إدخالاً)</spam
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>
